import { createContext } from 'react'

// The mobile buying flow supplies recommendations to eligible outfit pickers.
export default createContext(null)
